import api from './index'

let exports = {};
// ===================== 常规服务需求 =================
exports.getComnSvcRequirePagedList = function (data, callback) {// 获取常规服务需求分页列表
    api.post('/shop/comn/svc/require/paged/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getComnSvcRequireList = function (data, callback) {// 获取常规服务需求列表
    api.post('/shop/comn/svc/require/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getComnSvcRequireById = function (id, callback) {// 根据id获取常规服务需求
    api.get('/shop/comn/svc/require/get/by/id')
    .params({
        id: id
    })
    .done(callback)
    .fail(callback)
    .go();
};
// 保存常规服务需求
exports.saveComnSvcRequire = function (data, callback) {// 保存常规服务需求
    api.post('/shop/comn/svc/require/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 修改常规服务需求禁用标识
exports.doUpdateComnSvcRequireDisabled = function (data, callback) {// 修改常规服务需求禁用标识
    api.post('/shop/comn/svc/require/disabled/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 删除常规服务需求
exports.doDeleteComnSvcRequire = function (data, callback) {// 删除常规服务需求
    api.post('/shop/comn/svc/require/delete/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 批量执行
exports.doBatchSvcRequireBizTag = function (data, callback) {
    api.post('/shop/comn/svc/require/bizTag/batch/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// ======================= 门店可用常规需求 =============
// 获取常规服务请求分页列表
exports.getShopComnRepairPagedList = function (data, callback) {// 获取常规服务请求分页列表
    api.post('/shop/comn/repair/paged/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 获取常规服务请求列表
exports.getShopComnRepairList = function (data, callback) {// 获取常规服务请求列表
    api.post('/shop/comn/repair/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getShopComnRepairByRequireId = function (params, callback) {// 获取常规服务请求列表
    api.get('/shop/comn/repair/list/get/by/requireId')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 获取常规服务请详情
exports.getShopComnRepairInfo = function (params, callback) {// 获取常规服务请详情
    api.get('/shop/comn/repair/info/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 保存常规服务请求
exports.saveShopComnRepair = function (data, callback) {// 保存常规服务请求
    api.post('/shop/comn/repair/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 修改常规服务请求
exports.updateShopComnRepair = function (data, callback) {// 修改常规服务请求
    api.post('/shop/comn/repair/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 设置、清除默认服务商
exports.setShopComnRepairForDefServicer = function (data, callback) {
    api.post('/shop/comn/repair/clear/defServicer/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 禁用/启用常规服务请求
exports.doShopComnRepairDisabled = function (data, callback) {// 禁用/启用常规服务请求
    api.post('/shop/comn/repair/disabled/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 删除常规服务请求
exports.deleteShopComnRepair = function (data, callback) {// 删除常规服务请求
    api.post('/shop/comn/repair/delete/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 保存常规服务对应的服务商
exports.saveShopComnReqServicerBatch = function (data, callback) {// 删除常规服务请求
    api.post('/shop/comn/req/servicer/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.saveShopComnReqServicerList = function (data, callback) {// 删除常规服务请求
    api.post('/shop/comn/req/servicer/save/list/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 查看常规服务对应的服务商
exports.getShopComnReqServicerListByRepairId = function (data, callback) {// 删除常规服务请求
    api.post('/shop/comn/req/servicer/get/by/filter')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 修改常规服务是否允许抢单
exports.updateShopComnRepairGrabIssueAllowed = function (data, callback) {// 删除常规服务请求
    api.post('/shop/comn/repair/grabIssueAllowed/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 修改常规服务是否允许抢单
exports.updateShopComnRepairGrabIssueAllowedByIds = function (data, callback) {// 删除常规服务请求
    api.post('/shop/comn/repair/grabIssueAllowed/by/ids/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 查看默认服务商
exports.getShopComnRepairServicerList = function (data, callback) {// 删除常规服务请求
    api.post('/shop/comn/repair/servcer/get/repairId')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/shopComnReq.js
// module id = 128
// module chunks = 0